import React from "react";
import { Navbar, Nav } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import "./Navbar.css";

const NavbarComp = () => {
  const { pathname } = useLocation();

  return (
    <>
      <a href="/" style={{ textDecoration: "none", color: "inherit" }}>
        <h1 style={{ marginBottom: "0.2rem" }}>Subhed Chavan</h1>
        <p
          style={{
            fontSize: "0.95rem",
            fontWeight: 400,
            color: "#707070",
            marginBottom: "0.5rem",
          }}
        >
          Senior Software Engineer
        </p>
      </a>

      <div
        style={{ width: "100%", backgroundColor: "black", height: "12px" }}
      />

      <Navbar expand="lg">
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ml-auto">
            <Nav.Link href="/" active={pathname === "/"}>Home</Nav.Link>
            <Nav.Link href="/experience" active={pathname === "/experience"}>Experience</Nav.Link>
            <Nav.Link href="/projects" active={pathname === "/projects"}>Projects</Nav.Link>
            <Nav.Link href="/research" active={pathname === "/research"}>Research</Nav.Link>
            <Nav.Link href="/awards" active={pathname === "/awards"}>Awards</Nav.Link>
            <Nav.Link href="/contact" active={pathname === "/contact"}>Contact</Nav.Link>
          </Nav>

          <Nav className="m-auto"></Nav>

          <Nav className="mr-auto">
            <Nav.Link
              href="/resume/Subhed_Chavan.pdf"
              target="_blank"
              rel="noreferrer"
            >
              Resume
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </>
  );
};

export default NavbarComp;
